import { render, staticRenderFns } from "./CustomersConfiguration.vue?vue&type=template&id=52be4021&scoped=true&"
import script from "./CustomersConfiguration.vue?vue&type=script&lang=js&"
export * from "./CustomersConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CustomersConfiguration.vue?vue&type=style&index=0&id=52be4021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be4021",
  null
  
)

export default component.exports